<template>
  <section
      v-if="slug && isVisible"
      class="d-flex container-fluid position-absolute vw-100 px-0 vh-100 flex-column justify-content-center align-items-center gmb-l-modal-overlay"
      @click="hide()"
  >
    <div
        class="d-flex p-3 flex-column rounded-1 bg-theme-1 gmb-block--modal" :class="{ 'gmb-block--modal-small' : smallModalFormat}"
        @click.stop
    >
      <GmbDisplayHeading :text="title"/>

      <div class="d-flex mt-3 border-top pt-3"/>

      <div class="d-flex flex-grow-1 h-0 flex-column">
        <FdScroll y>
          <slot/>
        </FdScroll>
      </div>

      <div v-if="!noCloseButton" class="d-flex mt-3 border-top pt-3"/>

      <GmbRow v-if="!noCloseButton">
        <div class="d-flex justify-content-end">
          <b-button
              class="d-flex p-2 justify-content-center align-items-center text-size-reset rounded-1 btn-light"
              @click="hide()"
          >
            <FdText fa>
              <i class="fas fa-close"/>
            </FdText>
            <FdText class="mx-2" tag="span">Fermer</FdText>
          </b-button>
        </div>
      </GmbRow>
    </div>
  </section>
</template>

<script>
import ModalEventBus from "@/modalEventBus.js";

import FdScroll from "@/flexdesign/Scroll";
import FdText from "@/flexdesign/Text";

import GmbDisplayHeading from "@/widgets/DisplayHeading";
import GmbRow from "@/widgets/Row";

export default {
  name: "GmbModal",

  components: {
    FdScroll,
    FdText,
    GmbDisplayHeading,
    GmbRow,
  },

  props: {
    noCloseButton: Boolean,
    slug: String,
    title: String,
    smallModalFormat: Boolean,
  },

  data() {
    return {
      isVisible: false,
    };
  },

  computed: {},

  watch: {},

  beforeCreate() {
  },

  created() {
    ModalEventBus.$on("gmb-open-modal", this.checkForModalOpening);
    ModalEventBus.$on("gmb-close-modal", this.checkForModalClosing);
  },

  beforeMount() {
  },

  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {
    checkForModalClosing(modalSlug) {
      if (this.slug == modalSlug) this.isVisible = false;
    },

    checkForModalOpening(modalSlug) {
      if (this.slug == modalSlug) this.isVisible = true;
    },

    hide() {
      this.isVisible = false;
    },
  },
};
</script>

<style lang="scss">
@import "@/sass/settings/dimensions";

/* =========================================================================
 * MODAL
 * ========================================================================= */

.gmb-l-modal-overlay {
  min-width: $gmb-layout-width-min;
  min-height: $gmb-layout-height-min;
  background-color: rgba(#ffffff, 0.45);
}


</style>
